// extracted by mini-css-extract-plugin
export default {"singleSliderWrapper":"SingleSliderLoader_singleSliderWrapper__byl38","videoLoader":"SingleSliderLoader_videoLoader__0rrte","shine":"SingleSliderLoader_shine__xIN8i"};